<div class="hd-mystical">
  <header class="hd-mystical__header">
    <i [class]="'fas fa-' + icon + ' hd-mystical__header-icon'" aria-hidden="true"></i>
    <h3 class="hd-mystical__title">{{ vm().title }}</h3>
  </header>

  <!-- Algemene uitleg over het mystieke circuit -->
  @if (vm().introParagraphs.length > 0) {
    <section class="hd-mystical__intro">
      <h4 class="hd-mystical__block-title">{{ vm().introTitle }}</h4>
      @for (paragraph of vm().introParagraphs; track $index) {
        <p class="hd-mystical__paragraph">{{ paragraph }}</p>
      }
    </section>
  }

  <!-- De stroom in vijf bewegingen; de blokjes springen naar de detailsectie -->
  <section class="hd-mystical__stream">
    <h4 class="hd-mystical__block-title">{{ vm().streamTitle }}</h4>
    <ol class="hd-mystical__stages">
      @for (stage of vm().stages; track stage.stage) {
        <li class="hd-mystical__stage" [attr.data-stage]="stage.stage">
          <div class="hd-mystical__stage-head">
            <span class="hd-mystical__stage-name">{{ stage.name }}</span>
            @if (stage.keynote) {
              <span class="hd-mystical__stage-keynote">{{ stage.keynote }}</span>
            }
          </div>
          <div class="hd-mystical__stage-cards">
            @for (gate of stage.gates; track gate) {
              <button
                type="button"
                class="hd-mystical__card-button"
                [attr.data-hero-gate]="gate"
                [title]="vm().jumpHint"
                (click)="scrollToGate(gate)">
                <hd-circuit-gate-card scope="mystical" [gate]="gate" [rail]="railFor(gate)" size="compact" />
              </button>
            }
          </div>
        </li>
      }
    </ol>
  </section>

  <!-- Het einde van het circuit (2027) -->
  @if (vm().endingText) {
    <section class="hd-mystical__ending">
      <h4 class="hd-mystical__block-title">{{ vm().endingTitle }}</h4>
      <p class="hd-mystical__paragraph">{{ vm().endingText }}</p>
    </section>
  }

  <!-- Per poort het mystieke aspect, met de zes lijnen -->
  @if (vm().linesHint) {
    <p class="hd-mystical__lines-hint">{{ vm().linesHint }}</p>
  }
  <div class="hd-mystical__sections">
    @for (gate of gates; track gate) {
      <hd-circuit-gate-section
        class="hd-mystical__section"
        scope="mystical"
        [gate]="gate"
        [rail]="railFor(gate)"
        cardSize="compact"
        showKeynotes
        showLines />
    }
  </div>

  @if (vm().source) {
    <p class="hd-mystical__source">{{ vm().source }}</p>
  }
</div>
